import { Typography } from "@mui/material";
import { Box } from "@mui/system";

import checkIcon from "@assets/svg/check.svg";
import checkIconActive from "@assets/svg/check-active.svg";

type Props = {
  lineTrough?: boolean;
  checked: boolean;
  label: string;
};

const Bullet: React.FC<Props> = ({
  checked,
  label,
  lineTrough = true,
}: Props) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <img
        loading="lazy"
        src={checked ? checkIconActive : checkIcon}
        alt={`check icon ${checked ? "active" : "inactive"}`}
      />
      <Typography
        ml={1}
        color="text.hint"
        sx={{
          textDecoration: lineTrough && checked ? "line-through" : "none",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default Bullet;
